export const PROJECTS_FETCHING_ERROR_PREFIX = 'Failed to fetch projects';
